import { classnames } from '@aibees/shared/utils';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { RadioFilterLabelProps as Props } from './types';

export const RadioFilterLabel = memo(
  ({ className, value, children }: Props) => {
    return (
      <Typography
        className={classnames('RadioFilterLabel', className)}
        variant="body3"
        color="grey.600"
        fontWeight={600}
        component="label"
        sx={SX.root}
      >
        <Box display="flex" alignItems="center" gap={0.5}>
          {children}
          {value}
        </Box>
      </Typography>
    );
  }
);

RadioFilterLabel.displayName = 'RadioFilterLabel';
